type Props = {
  query: string;
};

export const defaultWindow = typeof window !== 'undefined' ? window : undefined;

export const useMedia = ({ query }: Props) => {
  const win = defaultWindow;
  const isSupported = computed(
    () => win && 'matchMedia' in win && typeof win.matchMedia === 'function',
  );

  let mediaQuery: MediaQueryList | undefined;
  const matches = ref(false);

  const update = () => {
    matches.value = !!mediaQuery?.matches;
  };

  onMounted(() => {
    if (!isSupported) {
      return;
    }

    mediaQuery = window.matchMedia(toRef(query).value);

    if (!mediaQuery.addEventListener) {
      // Safari
      mediaQuery.addListener(update);
    } else {
      mediaQuery.addEventListener('change', update);
    }

    update();
  });

  onUnmounted(() => {
    if (!mediaQuery) {
      return;
    }

    if (!mediaQuery.removeEventListener) {
      mediaQuery.removeListener(update);
    } else {
      mediaQuery.removeEventListener('change', update);
    }
  });

  return matches;
};
